import Auth from "@/store/auth";

let ComparisonGroups = function() {
  this.get = function() {
    return new Promise(resolve => {
      let url = process.env.VUE_APP_API + "comparison_groups/";

      fetch(url, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + Auth.getters.getJwt
        }
      }).then(response => {
        if (response.status === 200) {
          response.json().then(json => {
            resolve(json);
          });
        } else if (response.status === 401) {
          Auth.dispatch("setJwt", "").catch(err => {
            console.error(err);
          });
          resolve(false);
        }
      });
    });
  };

  this.add = function(mainGroupId, name, shortName, refImage) {
    return new Promise(resolve => {
      let url = process.env.VUE_APP_API + "comparison_groups/";

      let data = {
        mainGroupId: mainGroupId,
        name: name,
        shortName: shortName,
        refImage: refImage
      };
      fetch(url, {
        method: "PUT",
        body: JSON.stringify(data),
        headers: {
          Authorization: "Bearer " + Auth.getters.getJwt
        }
      }).then(response => {
        if (response.status === 200) {
          response.json().then(json => {
            resolve(json.result);
          });
        } else if (response.status === 401) {
          Auth.dispatch("setJwt", "").catch(err => {
            console.error(err);
            resolve(false);
          });
        }
      });
    });
  };

  this.update = function(groupId, mainGroupId, name, shortName, refImage) {
    return new Promise(resolve => {
      let url = process.env.VUE_APP_API + "comparison_groups/" + groupId + "/";

      let data = {
        mainGroupId: mainGroupId,
        name: name,
        shortName: shortName,
        refImage: refImage
      };
      fetch(url, {
        method: "PUT",
        body: JSON.stringify(data),
        headers: {
          Authorization: "Bearer " + Auth.getters.getJwt
        }
      }).then(response => {
        if (response.status === 200) {
          response.json().then(json => {
            resolve(json.result);
          });
        } else if (response.status === 401) {
          Auth.dispatch("setJwt", "").catch(err => {
            console.error(err);
            resolve(false);
          });
        }
      });
    });
  };

  this.deleteGroup = function(groupId) {
    return new Promise(resolve => {
      let url = process.env.VUE_APP_API + "comparison_groups/" + groupId + "/";

      fetch(url, {
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + Auth.getters.getJwt
        }
      }).then(response => {
        if (response.status === 200) {
          response.json().then(json => {
            resolve(json.result);
          });
        } else if (response.status === 401) {
          Auth.dispatch("setJwt", "").catch(err => {
            console.error(err);
            resolve(false);
          });
        }
      });
    });
  };
};

export default new ComparisonGroups();
